"use client";

type PharmacyWarehouseBackdropProps = {
  /** `fixed` for route-level upload; `absolute` when nested (e.g. batch scan). */
  position?: "fixed" | "absolute";
};

/**
 * One blue-grey plate + a very slow drifting highlight (motion respects reduced-motion).
 */
export function PharmacyWarehouseBackdrop({ position = "fixed" }: PharmacyWarehouseBackdropProps) {
  return (
    <div
      className="ed-upload-atmosphere"
      aria-hidden
      style={{
        position,
        inset: 0,
        width: "100%",
        height: "100%",
        zIndex: 0,
        pointerEvents: "none",
      }}
    >
      <div className="ed-upload-atmosphere__plate" />
      <div className="ed-upload-atmosphere__drift" />
    </div>
  );
}
